import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { StoreStatus } from "../../types/enum/storeStatus";
import {
  InCompleteStore,
  StoreAdmin,
  StoreAdminDetails,
} from "../../types/modules/admin/StoreAdmin.type";

interface UseParams {
  page?: number;
  limit?: number;
  status: StoreStatus;
  name?: string;
  phone?: string;
  commercialRegister?: string;
  city?: string;
  type?: string;
  subType?: string;
  dateFilter?: string;
}

export const useStoresByAdmin = ({
  page = 1,
  limit = 9,
  status,
  name = "",
  phone = "",
  commercialRegister = "",
  city = "",
  type = "",
  subType = "",
  dateFilter = "",
}: UseParams) => {
  const token = getAdminAccessToken();
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    status: status,
    name: name,
    phone: phone,
    commercialRegister: commercialRegister,
    city: city,
    type: type,
    subType: subType,
    dateFilter: dateFilter,
  });
  return useQuery({
    queryKey: [
      "stores-by-admin",
      page,
      limit,
      status,
      name,
      phone,
      commercialRegister,
      city,
      type,
      subType,
      dateFilter,
    ],
    queryFn: () =>
      fetcher<{ stores: StoreAdmin[]; total: number; totalPages: number }>(
        `store/admin/all?${queryParams.toString()}`,
        token
      ),
  });
};

export const useStorDetailsByAdmin = (storeId: number) => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["store-detalis-by-admin", storeId],
    queryFn: () =>
      fetcher<StoreAdminDetails>(`store/admin/${storeId}/details`, token),
  });
};

interface UseParams2 {
  page?: number;
  limit?: number;
}

export const useStoresInCompleteByAdmin = ({
  page = 1,
  limit = 10,
}: UseParams2) => {
  const token = getAdminAccessToken();
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  return useQuery({
    queryKey: ["stores-incompletes-by-admin", limit, page],
    queryFn: () =>
      fetcher<{ stores: InCompleteStore[]; total: number; totalPages: number }>(
        `store/admin/all/incomplete?${queryParams.toString()}`,
        token
      ),
  });
};
